import { render, staticRenderFns } from "./CustomerSummaryAccountStatement.vue?vue&type=template&id=cada2df2&scoped=true&"
import script from "./CustomerSummaryAccountStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerSummaryAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cada2df2",
  null
  
)

export default component.exports